var AutoCompleteConfig = (function () {
    function AutoCompleteConfig(dataSource, suggestFromCharNumber, placeholder, dataKey, dataValue, dataValue2) {
        if (dataValue2 === void 0) { dataValue2 = ""; }
        this.placeholder = placeholder;
        this.dataSource = dataSource;
        this.suggestFromCharNumber = suggestFromCharNumber;
        this.dataKey = dataKey;
        this.dataValue = dataValue;
        this.dataValue2 = dataValue2;
        //this.valueDefault = value;
    }
    return AutoCompleteConfig;
}());
export { AutoCompleteConfig };
//# sourceMappingURL=autocomplete.config.js.map